import type { Reducer } from 'react'

interface FetchDynamicMuiIconReducerState {
  isLoading: boolean
  data: string | undefined
  error: string | undefined
}
interface FetchDynamicMuiIconReducerAction {
  type: 'LOADING' | 'SUCCESS' | 'ERROR'
  payload?: string
}

export const initialFetchDynamicMuiIconReducerState: FetchDynamicMuiIconReducerState = {
  isLoading: false,
  data: undefined,
  error: undefined
}

export const fetchDynamicMuiIconReducer: Reducer<
  FetchDynamicMuiIconReducerState,
  FetchDynamicMuiIconReducerAction
> = (state, action) => {
  switch (action?.type) {
    case 'LOADING':
      return {
        ...state,
        isLoading: true
      }
    case 'SUCCESS':
      return {
        ...state,
        isLoading: false,
        data: action.payload
      }
    case 'ERROR':
      return {
        ...state,
        isLoading: false,
        error: action.payload
      }
    default:
      return state
  }
}
